import { YardInternalMovesApi, YardInternalMovesApiYardInternalMovesCreateMoveRequest } from '@storage/app/api'
import { createApiClient } from '@storage/app/http-client'

export class MoveContainerService {
  async moveContainer(request: YardInternalMovesApiYardInternalMovesCreateMoveRequest) {
    await createApiClient(YardInternalMovesApi).yardInternalMovesCreateMove(request)
  }
}
